export default class CometChat {}